import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { apiConnector } from '../../../../../services/apiConnector';
import { imageEndpoints } from '../../../../../services/apis'; 
import { deleteImage } from '../../../../../services/operations/ImageAPI';

const { GET_ALL_IMAGES_API } = imageEndpoints;

const ImageTable = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const truncateDescription = (description) => {
    if (!description) return '';
    const words = description.split(' ');
    return words.length > 10 ? words.slice(0, 10).join(' ') + '...' : description;
  };

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      try {
        const response = await apiConnector("GET", GET_ALL_IMAGES_API);
        if (!response.data) {
          throw new Error('No data found');
        }
        setImages(response.data); // Adjust based on your API response
      } catch (err) {
        setError(err.message);
        toast.error("Failed to fetch images");
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  const handleDelete = async (imageId) => {
    const deleteImageFunction = deleteImage(imageId);
    await deleteImageFunction();
    setImages((prevImages) => prevImages.filter((image) => image._id !== imageId));
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Image URL</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {images?.map((image) => (
            <tr key={image._id}>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{image._id}</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{image.category.name}</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{truncateDescription(image.description)}</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <a href={image.images[0]} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">View Image</a>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <button 
                  onClick={() => handleDelete(image._id)} 
                  className="text-red-500 hover:text-blue-500"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ImageTable;
